import script from "./Chatbot.vue?vue&type=script&setup=true&lang=js"
export * from "./Chatbot.vue?vue&type=script&setup=true&lang=js"

import "./Chatbot.vue?vue&type=style&index=0&id=15945562&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15945562"]])

export default __exports__